import React, { ReactNode } from 'react';
import { Flex, Text } from '@adobe/react-spectrum';
import { TextAlign } from 'chart.js';

interface LabeledValueType {
  label: string;
  value: string | ReactNode;
  width?: string;
  textAlign?: TextAlign;
  labelFont?: string;
  valueFont?: string;
  fontWeight?: string;
}
const LabeledValue: React.FC<LabeledValueType> = ({ label, value, width, textAlign, labelFont, valueFont, fontWeight }) => {
  return (
    <Flex direction={'column'} gap={'size-10'} width={width}>
      <Text
        UNSAFE_style={{
          fontSize: labelFont ? labelFont : '14px',
          textAlign: textAlign ? `${textAlign}` : 'left',
          overflow: 'hidden',
          fontWeight: fontWeight ? fontWeight : '',
        }}
      >
        {label}
      </Text>

      <Text
        UNSAFE_style={{
          fontSize: valueFont ? valueFont : '16px',
          overflow: 'hidden',
          textAlign: textAlign ? `${textAlign}` : 'left',
          fontWeight: fontWeight ? fontWeight : '',
        }}
      >
        <span title={value as string}>{value}</span>
      </Text>
    </Flex>
  );
};

export default LabeledValue;
